/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

/* global Cookies sf$ gup throttleAfter throttleDomAfterAsync*/

(function($) {

  //settings
  const scrollEffectDelay = 0;//delay any scroll events by this many MS

  //define common values
  const scrollOffset = 72;
  const scrollTime = 400;

  // cache common selectors (script is in footer, so no need to wait until doc ready)
  const $document = $(document);// eslint-disable-line no-unused-vars
  const $window = $(window);// eslint-disable-line no-unused-vars
  const $html = $('html');// eslint-disable-line no-unused-vars
  const $htmlBody = $('html, body');// eslint-disable-line no-unused-vars
  const $body = $('body');// eslint-disable-line no-unused-vars
  const $topNav = $body.find('.top');// eslint-disable-line no-unused-vars
  const $footer = $body.find('#main-footer');// eslint-disable-line no-unused-vars
  const $menuOverlay = $body.find('.menuOverlay');// eslint-disable-line no-unused-vars
  const $modules = $body.find("[data-module],.module");// eslint-disable-line no-unused-vars
  const $socialNav = $body.find('.social-nav');// eslint-disable-line no-unused-vars
  const $quizBlock = $body.find('#quiz-block');// eslint-disable-line no-unused-vars
  const $takeActionMenu = $body.find(".take-action-menu");

  //mutable dimensions
  let topNavHeight = $topNav.height();// eslint-disable-line no-unused-vars
  let footerHeight = $footer.height();// eslint-disable-line no-unused-vars
  let socialHideRanges = getSocialHides();// eslint-disable-line no-unused-vars

  //figure out ~where social hide sections are ahead of time
  function getSocialHides(){
    const hideRanges = [];
    $body.find('.social-hide').each((i,el)=>{
      const { offsetTop, offsetHeight } = el;
      hideRanges.push([offsetTop, offsetHeight+offsetTop])
    });
    return hideRanges;
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Base = {
    // All pages
    common: {
      init: function() {

        // JavaScript to be fired on all pages

        $window.one('resize', () => $html.addClass('was-resized'));
        if (navigator.appVersion && navigator.appVersion.indexOf("MSIE 10") !== -1) {
          jQuery("html").addClass("ie10");
        }
        // MOBILE MENU
        function openMenu(e) {
          $menuOverlay.addClass('menu--open temp-high-z');
          e.preventDefault();
          $html.addClass('noScroll');
        }

        function closeMenu(e) {
          $html.removeClass('noScroll');
          $menuOverlay.removeClass('menu--open');
          e.preventDefault();
          e.stopPropagation();
					setTimeout( function() {
						$menuOverlay.removeClass( 'temp-high-z' );
					}, 200 );
        }

        /* Interrupt download to make registration required */
        const $downloadBtns = $body.find('.btn-file-download');
        const hasRegistered = window.localStorage.getItem('hasRegistered') || false;

        /* Only run download interruptions if user not registered */
        $downloadBtns.on('click', function(e){
          if(!hasRegistered){
            e.preventDefault();

            const currentLocation = window.location.href;
            const redirectLink = $(this).data('register');
            const downloadLink = $(this).attr('href');

            /* Set local storage items to come back to */
            window.localStorage.setItem('downloadReturnUrl', currentLocation);
            window.localStorage.setItem('downloadFile', downloadLink);

            window.location.href = "/access-download/";
          }
        });

        $body
          .on('click','#btn-menu', openMenu)
          .on('click','#btn-menu-close', closeMenu);

        //close on ESC
        document.addEventListener('keyup', ev => ev.keyCode === 27 && closeMenu(ev) );
        //END MENU

        //action network
        $( document ).on( 'can_embed_loaded', function() {
          $( '.action-form' ).css({opacity: 1});
          $( '.action-form form[novalidate]' ).removeAttr( 'novalidate' );

          $( '.topper-cta' ).css({visibility: 'visible'});

          $( '.action-form [name="answer[email]"]' )
            .attr('title','Email Address')
            .attr( 'required', 'required' )
            .prop('require',true);

          $( '.action-form [name="answer[zip_code]"]' )
            .attr('title', '5-Digit ZIP Code')
            .attr( 'required', 'required' )
            .prop('require',true)
            .attr( 'pattern', '[0-9]{5}' )
            .attr( 'maxlength', '5' );
        } );


        $body
          .find('.video-popup').magnificPopup({
              type: 'iframe',
              mainClass: 'mfp-fade',
              removalDelay: 160,
              preloader: false,
              fixedContentPos: false
          });

				$body
          .find('.popup-youtube').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
          });

        jQuery('body')
          .find('#resources-wrapper .articles, #threeRs-wrapper .articles, #post-wrapper .articles').masonry({
            itemSelector: '.col-md-6'
          });

				$body
          .find('.image-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });

        $body
          .find('.resources-slider').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            appendArrows: $('.resource-arrows'),
            prevArrow: '<a class="slick-prev" title="Previous"><svg id="nextArrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.84 91.84"><title>arrow-grid</title><path d="M91.84,50A41.86,41.86,0,1,1,79.58,20.42,41.8,41.8,0,0,1,91.84,50ZM4.08,50A46,46,0,1,0,17.56,17.56,45.92,45.92,0,0,0,4.08,50Z" transform="translate(-4.08 -4.08)"/><path d="M56.22,36.73,67.35,48H27.65a2,2,0,1,0,0,4.08h39.8L56.22,63.27a2.05,2.05,0,0,0,3,2.85l14.6-14.69a2.05,2.05,0,0,0,.2-2.55l-.2-.2v-.1l-14.7-14.7a2,2,0,0,0-2.86,2.86Z" transform="translate(-4.08 -4.08)"/></svg></a>',
            nextArrow: '<a class="slick-next" title="Next"><svg id="nextArrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.84 91.84"><title>arrow-grid</title><path d="M91.84,50A41.86,41.86,0,1,1,79.58,20.42,41.8,41.8,0,0,1,91.84,50ZM4.08,50A46,46,0,1,0,17.56,17.56,45.92,45.92,0,0,0,4.08,50Z" transform="translate(-4.08 -4.08)"/><path d="M56.22,36.73,67.35,48H27.65a2,2,0,1,0,0,4.08h39.8L56.22,63.27a2.05,2.05,0,0,0,3,2.85l14.6-14.69a2.05,2.05,0,0,0,.2-2.55l-.2-.2v-.1l-14.7-14.7a2,2,0,0,0-2.86,2.86Z" transform="translate(-4.08 -4.08)"/></svg></a>',
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });

        $body
          .find('.feat-activist-grid').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $('.grid-arrows'),
            prevArrow: '<a class="slick-prev" title="Previous"><svg id="nextArrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.84 91.84"><title>arrow-grid</title><path d="M91.84,50A41.86,41.86,0,1,1,79.58,20.42,41.8,41.8,0,0,1,91.84,50ZM4.08,50A46,46,0,1,0,17.56,17.56,45.92,45.92,0,0,0,4.08,50Z" transform="translate(-4.08 -4.08)"/><path d="M56.22,36.73,67.35,48H27.65a2,2,0,1,0,0,4.08h39.8L56.22,63.27a2.05,2.05,0,0,0,3,2.85l14.6-14.69a2.05,2.05,0,0,0,.2-2.55l-.2-.2v-.1l-14.7-14.7a2,2,0,0,0-2.86,2.86Z" transform="translate(-4.08 -4.08)"/></svg></a>',
            nextArrow: '<a class="slick-next" title="Next"><svg id="nextArrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.84 91.84"><title>arrow-grid</title><path d="M91.84,50A41.86,41.86,0,1,1,79.58,20.42,41.8,41.8,0,0,1,91.84,50ZM4.08,50A46,46,0,1,0,17.56,17.56,45.92,45.92,0,0,0,4.08,50Z" transform="translate(-4.08 -4.08)"/><path d="M56.22,36.73,67.35,48H27.65a2,2,0,1,0,0,4.08h39.8L56.22,63.27a2.05,2.05,0,0,0,3,2.85l14.6-14.69a2.05,2.05,0,0,0,.2-2.55l-.2-.2v-.1l-14.7-14.7a2,2,0,0,0-2.86,2.86Z" transform="translate(-4.08 -4.08)"/></svg></a>'
          });

        $body
          .find('.our-campaigns-grid').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            appendArrows: $('.our-campaign-grid-arrows'),
            prevArrow: '<a class="slick-prev" title="Previous"><svg id="nextArrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.84 91.84"><title>arrow-grid</title><path d="M91.84,50A41.86,41.86,0,1,1,79.58,20.42,41.8,41.8,0,0,1,91.84,50ZM4.08,50A46,46,0,1,0,17.56,17.56,45.92,45.92,0,0,0,4.08,50Z" transform="translate(-4.08 -4.08)"/><path d="M56.22,36.73,67.35,48H27.65a2,2,0,1,0,0,4.08h39.8L56.22,63.27a2.05,2.05,0,0,0,3,2.85l14.6-14.69a2.05,2.05,0,0,0,.2-2.55l-.2-.2v-.1l-14.7-14.7a2,2,0,0,0-2.86,2.86Z" transform="translate(-4.08 -4.08)"/></svg></a>',
            nextArrow: '<a class="slick-next" title="Next"><svg id="nextArrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.84 91.84"><title>arrow-grid</title><path d="M91.84,50A41.86,41.86,0,1,1,79.58,20.42,41.8,41.8,0,0,1,91.84,50ZM4.08,50A46,46,0,1,0,17.56,17.56,45.92,45.92,0,0,0,4.08,50Z" transform="translate(-4.08 -4.08)"/><path d="M56.22,36.73,67.35,48H27.65a2,2,0,1,0,0,4.08h39.8L56.22,63.27a2.05,2.05,0,0,0,3,2.85l14.6-14.69a2.05,2.05,0,0,0,.2-2.55l-.2-.2v-.1l-14.7-14.7a2,2,0,0,0-2.86,2.86Z" transform="translate(-4.08 -4.08)"/></svg></a>',
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });

        $body.on('click','a.scroll-read-more', function(e) {
            e.preventDefault();
            const scrollTop = $( $(this).attr("href") ).offset().top - scrollOffset
            $htmlBody.animate({ scrollTop }, scrollTime);
        });

        //add class to last module
        $modules.last().addClass('last-module');

        $body.on('click', '.social .social-pop', function(e) {
          if ($window.width() > 967) {
            e.preventDefault();
            window.open(
              this.href,
                '',
              'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=350,width=600'
            );
          }
        });

        var currentID = 1;
        $body.find('.video-share .videoWrapper iframe').each(function(){
            $(this).attr('id', currentID);
            //$(this).appendAttr('src', '&autoplay=0');
            $(this).attr("src", $(this).attr("src") + "&autoplay=0");
            $(this).attr("src", $(this).attr("src") + "&rel=0");
            currentID++;
        });

        var current = 1;
        $body.find('.video-cover').each(function(){
          var findVideo = $('#' + current);
          $(this).click(function() {
              $(this).fadeOut();
              $(findVideo).attr("src", $(findVideo).attr("src").replace("autoplay=0", "autoplay=1"));
          });
          current++;
        });

        // Home Page Video Popup
        $body.find('.pop-over .videoWrapper iframe').each(function(){
            $(this).attr('id', currentID);
            //$(this).appendAttr('src', '&autoplay=0');
            $(this).attr("src", $(this).attr("src") + "&autoplay=1");
            $(this).attr("src", $(this).attr("src") + "&rel=0");
            currentID++;
        });

        $document.on('click touchstart', function(event) {
            if(!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
                if($('.pop-over').is(":visible")) {
                    $('.pop-over').hide();
                    const iFrameSrc = $('.pop-over .videoWrapper iframe').attr('src');
                    if(iFrameSrc){
                      $('.pop-over .videoWrapper iframe').attr('src', iFrameSrc.replace('autoplay=1', 'autoplay=0'));
                    }
                }
            }
        });

        $body.find('.play-button').click(function(event) {
            if(!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
                if($('.pop-over').is(":visible")) {
                    $('.pop-over').hide();
                }
            }
        });

        //Selectric
        $(function () {
          $('.filter-form select').selectric({
            disableOnMobile: false
          });
        });

        // Example approach with jQuery, classes will differ in each
        // individual case.

        $('.searchandfilter').append('<button type="submit"></button>');
        $('.searchandfilter [type="submit"]').hide();

        $('.sf-field-taxonomy-type select, .sf-field-taxonomy-audience select, .sf-field-taxonomy-language select, .sf-field-taxonomy-grade select, .sf-field-taxonomy-type_3rs select, .sf-field-taxonomy-topic select').on('selectric-select', (event, element, selectric) => {
          $('.searchandfilter [type="submit"]').click();
        });

        function topicLabelReplacement() {

          $('.sf-field-taxonomy-topic h4, .sf-field-taxonomy-type_3rs h4, .sf-field-taxonomy-grade h4').hide();

          var headerTopicText = $('.sf-field-taxonomy-topic h4').html();
          var headerTypeText = $('.sf-field-taxonomy-type_3rs h4').html();
          var headerGradeText = $('.sf-field-taxonomy-grade h4').html();


          function clearEmpties(){
            $body.find('.chosen-container').each((i,el)=>{
              const $el = $(el);
              const $choices = $el.find('.search-choice');
              if(!$choices.length){
                $el.hide();
              }else{
                $el.show();
              }

              const indexesAfter = {};

              $choices.each((i,el)=>{
                const index = $(el).find('.search-choice-close').data('option-array-index');
                indexesAfter[index] = true;
              });

              const $selectricChoices = $el.prev('.selectric-wrapper');

              $selectricChoices.find('.selectric-scroll li.selected').each((i,el)=>{
                const index = $(el).data('index');
                if(!indexesAfter[index]){
                  console.log(`eliminating ${$(el).text()}`)
                  el.click();
                }
              });


            })
          }

          $body.on('click','.filter-form .search-choice', function(e){
            e.preventDefault();
            $(this).find('.search-choice-close').get(0).click();
            clearEmpties();
          });


          const $s_topic = $body.find('.sf-field-taxonomy-topic .selectric span.label');
          const $s_type = $body.find('.sf-field-taxonomy-type_3rs .selectric span.label');
          const $s_grade = $body.find('.sf-field-taxonomy-grade .selectric span.label');


          function fixTitles(){
            //console.log({headerTopicText, headerTypeText, headerGradeText})
            $s_topic.html(headerTopicText);
            $s_type.html(headerTypeText);
            $s_grade.html(headerGradeText);
          }
          // console.log($.fn.jquery);
          //console.log(sf$.fn.jquery);
          sf$( document ).ajaxStart(function(e, a, b, c) {
            console.log('started');
            clearEmpties();
            fixTitles();
            setTimeout( fixTitles, 400)
          });
          sf$( document ).ajaxStop(function(e, a, b, c) {
            clearEmpties();
            fixTitles();
            jQuery('body').find('#resources-wrapper .articles, #threeRs-wrapper .articles, #post-wrapper .articles').masonry({
              itemSelector: '.col-md-6'
            });
          });


          setTimeout(function(){
            
            
            $('.filter-form li[data-sf-field-input-type="multiselect"] .button').html('<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><title>plus-filter</title><polygon class="cls-1" points="16.25 10.29 12.67 10.33 12.71 6.75 10.29 6.75 10.29 10.29 6.75 10.29 6.75 12.71 10.29 12.71 10.29 16.25 12.71 16.25 12.67 12.67 16.25 12.71 16.25 10.29"/><path class="cls-1" d="M12.39,2.89a9.5,9.5,0,1,1-9.5,9.5,9.51,9.51,0,0,1,9.5-9.5m0-2a11.5,11.5,0,1,0,11.5,11.5A11.5,11.5,0,0,0,12.39.89Z" transform="translate(-0.89 -0.89)"/></svg>');


            var gradesChoicesCount = $('.sf-field-taxonomy-grade .chosen-container .chosen-choices').children().length;

            if (gradesChoicesCount > 1) {
              $('.sf-field-taxonomy-grade .chosen-container').addClass('not-empty').removeClass('empty');
            } else {
              $('.sf-field-taxonomy-grade .chosen-container').addClass('empty').removeClass('not-empty');
            }


            var typeChoicesCount = $('.sf-field-taxonomy-type_3rs .chosen-container .chosen-choices').children().length;

            if (typeChoicesCount > 1) {
              $('.sf-field-taxonomy-type_3rs .chosen-container').addClass('not-empty').removeClass('empty');
            } else {
              $('.sf-field-taxonomy-type_3rs .chosen-container').addClass('empty').removeClass('not-empty');
            }

            var topicChoicesCount = $('.sf-field-taxonomy-topic .chosen-container .chosen-choices').children().length;

            if (topicChoicesCount > 1) {
              $('.sf-field-taxonomy-topic .chosen-container').addClass('not-empty').removeClass('empty');
            } else {
              $('.sf-field-taxonomy-topic .chosen-container').addClass('empty').removeClass('not-empty');
            }
            fixTitles();

          }, 50);
          setTimeout( fixTitles, 400)

        }

        
        // $('.searchandfilter li[data-sf-field-input-type="multiselect"] label').on('touchstart', function (e) {
        //   // e.stopPropagation(); e.preventDefault();

        //   // Trigger the mousedown event.
        //   $(this).find('.chosen-container').trigger('mousedown');
        //   // alert('Triggered');
        // });
       


        $document.ready(function(){
          topicLabelReplacement();
        });

        // Topper class of active
        $(document).ready(function () {
          $('.topper').addClass('active');
        });


        // TAKE ACTION MENU
        $body.on("click", "li.take-action a", function (e) {
          e.preventDefault();
          $takeActionMenu.addClass('take-action-menu--open');
        });

        $body.on("click", ".take-action-menu .close", function () {
          $takeActionMenu.removeClass('take-action-menu--open');
          setTimeout(
            function () { $takeActionMenu.removeClass('temp-high-z'); }
            , 100);
        });

        $(document).keyup(function (e) {
          if (e.keyCode == 27) { // esc keycode
            $takeActionMenu.removeClass('take-action-menu--open');
            setTimeout(
              function () { $takeActionMenu.removeClass('temp-high-z'); }
              , 100);
          }
        });
        // END TAKE ACTION MENU

        //alert bar
        const $alertBar = $body.find( ".alert-bar" );

        $body.on( 'click', '.alert-bar__close', function() {
          $alertBar.slideToggle( 'fast' , function() {
            $alertBar.prop( 'hidden', true );
            topNavHeight = $topNav.height();
          });
          if(window.ALERT_OPTIONS && window.ALERT_OPTIONS.alert_is_cookied){
            Cookies.set( 'alertbar', window.ALERT_OPTIONS && window.ALERT_OPTIONS.cookievalue || 'value', { expires: 7 } );
          }
        } );

        // eslint-disable-next-line no-unused-vars
        const positionStickySupport = function() {
         var el = document.createElement('a'),
             mStyle = el.style;
         mStyle.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;";
         return mStyle.position.indexOf('sticky')!==-1;
        }();

        $html.toggleClass('nopositionsticky', !positionStickySupport);

        // addSticky :: Int -> () -> IO (side-effect, adds or removes class)
        // eslint-disable-next-line no-unused-vars
        const addSticky = throttleDomAfterAsync( (e = {}) => {
          const { target = {} } = e;
          let { scrollingElement: { scrollTop } = {} } = target;

          if(!scrollTop){
            scrollTop = $window.scrollTop();
          }

          $topNav.toggleClass('is-sticky', scrollTop >= topNavHeight);
        }, scrollEffectDelay);


        $window.on('scroll', addSticky);
        addSticky();

        function resizeContent() {
            var $height = $window.height() - 72;
            if ($window.width() > 768) {
              if ($window.height() > 750) {
                $quizBlock.addClass('attached').height($height);
              } else {
                $quizBlock.height('auto').removeClass('attached');
              }
          }
        }

        if($quizBlock.length){
          $window.resize(resizeContent);
          resizeContent();
        }

        // Lettering for uinderlines
        $('.topper h1, .special-underline').lettering('words');

        // Social Hide

        //Icon Detection: Not Used?
        // var $sticky_share = $('.content');

        // function check_if_in_view() { // eslint-disable-line no-unused-vars
        //   var window_height = $window.height();
        //   var window_top_position = $window.scrollTop();
        //   var window_bottom_position = (window_top_position + window_height);

        //   $.each($sticky_share, function() {
        //     var $element = $(this);
        //     var element_height = $element.outerHeight();
        //     var element_top_position = $element.offset().top;
        //     var element_bottom_position = (element_top_position + element_height);

        //     //check to see if this current container is within viewport
        //     if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position - 400)) {
        //       $socialNav.addClass('in-view');
        //     }
        //     // else {

        //     // }
        //   });

        // }

        /* Magical function to detect overlaps*/
        $.fn.overlaps = function(objs) {
          var elems = {targets: [], hits:[]};
          this.each(function() {
            var bounds = $(this).offset();
            bounds.right = bounds.left + $(this).outerWidth();
            bounds.bottom = bounds.top + $(this).outerHeight();

            $(objs).each(function(){
              var obj = this;
              var compare = $(obj).offset();
              compare.right = compare.left + $(obj).outerWidth();
              compare.bottom = compare.top + $(obj).outerHeight();

              if (!(compare.right < bounds.left ||
                    compare.left > bounds.right ||
                    compare.bottom < bounds.top ||
                    compare.top > bounds.bottom)
                 ) {
                  elems.targets.push(this);
                  elems.hits.push(obj);
              }
            });
          });

          return elems;
        };

        if ($('.social-nav').length > -1) {
          const check_overlap = throttleDomAfterAsync(()=>{
              var stickyShare = $socialNav.overlaps('.social-hide');
              $socialNav[stickyShare.hits.length? 'addClass' : 'removeClass']('behind');
              $socialNav[stickyShare.hits.length? 'addClass' : 'removeClass']('animate');
          }, scrollEffectDelay);

          $window.on('scroll resize', check_overlap);
          check_overlap();
          // End Social Hide
        }

        // Print action
        $('.js-print').on('click', function(e) {
          e.preventDefault();
          window.print();
        });

        const checkActiveSections = throttleDomAfterAsync(function() {
          $modules.each(function(i, el) {
            var $el = $(el);
            $el.toggleClass("activeSection", $el.visible(true));
          });
        }, scrollEffectDelay);

        $window.on('scroll', checkActiveSections);

        //LANDING PAGE
        $body
          .on('mouseenter','.scroll', function() {
              $(this).next('.tool').css('opacity', '1');
          })
          .on('mouseleave','.scroll', function() {
              $(this).next('.tool').css('opacity', '0');
          })
          .on('click', '.scroll', function(e) {
              e.preventDefault();
              const scrollAnchor = $(this).attr('data-scroll');
              const scrollTop = $('.module[data-anchor="' + scrollAnchor + '"]').offset().top - 72;

              $htmlBody.animate({ scrollTop }, 500);
          });


        $.fn.visible = function(partial) {
              var $t            = $(this),
                  $w            = $window,
                  viewTop       = $w.scrollTop() - 72,
                  viewBottom    = viewTop + $w.height() - 72,
                  _top          = $t.offset().top - 72,
                  _bottom       = _top + $t.height() - 72,
                  compareTop    = partial === true ? _bottom : _top,
                  compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

        };

        const $dottedNav = $('.dotted-nav');

        if ($dottedNav.length) {

          //this seems like a lot of work to change one thing white on scroll
          const checkWhiteClass = throttleDomAfterAsync(() => {
              var window_size = $window.height()/2;
              var scrollPosition = $window.scrollTop();
              if (scrollPosition >= window_size) {
                $('.dotted-nav').removeClass('white');
              } else {
                $('.dotted-nav').addClass('white');
              }
          }, scrollEffectDelay);

          $window.on('scroll', checkWhiteClass);

          //activate dotted nav on load
          const s = $('.module.activeSection').attr('id');
          $dottedNav.find(`a#${s}`).addClass('active');

          //event to check which section is active
          const toggleNavColorScroll = throttleDomAfterAsync(() => {
            var s = $('.module.activeSection').attr('id');
            $dottedNav.find('a.active').removeClass('active');
            $dottedNav.find(`a#${s}`).addClass('active');
          }, scrollEffectDelay);

          $window.on('scroll', toggleNavColorScroll);
        }

        $body.on('click','.smooth_scroll', function(e){

            e.preventDefault();
            const $target = $($(this).attr('href'));//usually a #hash selector...

            if($target.length){
              const scrollTop = $target.offset().top - scrollOffset;

              //Animate
              $htmlBody.stop().animate({ scrollTop }, scrollTime);
            }
        });


        //add dynamic sourcing to contribution link
        $('header .contribute-link a').each(function(){
          const $this = $(this);
          const source = Cookies.getJSON('source') || gup('source') || 'website';

          const sourcedUrl = $this.attr('href')
            .replace('website', source)
            .replace('=homepage',`=${source}`);

          $this.attr('href', sourcedUrl);
          // if(source!='website'){
          //  history.replaceState(null, null, "?source="+source);
          // }
        });

        //Search
        const searchType = $body.data('searchtype');

        if(searchType === 'pageOverlay'){

          const openSearch = e => {
            e.preventDefault();
            $('.searchOverlay').addClass('search--open temp-high-z');
            $('.search__input').focus();
            $('html').addClass('noScroll');
          };
          const closeSearch = e => {
            $('html').removeClass('noScroll');
            e.preventDefault();
            $('.searchOverlay').removeClass('search--open');
            $('.search__input').blur();
            $('.search__input').val('');
						setTimeout( function() {
							$( '.searchOverlay' ).removeClass( 'temp-high-z' );
						}, 100 );
          }


          $('.search__input').keypress(function(event) {
              if (event.which == 13) {
                  event.preventDefault();
                  $(".searchOverlay [data-searchform]").submit();
              }
          });

          $body.on('click','#btn-search', openSearch);
          $body.on('click','#btn-search-close', closeSearch);

          document.addEventListener('keyup', function(e) {
            if( e.keyCode == 27 ) {
              closeSearch(e);
            }
          });

        } else {
          //pulldown search
          $body
            .on('click', "#btn-search, #search-trigger", function(e) {
              e.preventDefault();
              e.stopPropagation();
              $('.top-search .focus-input').focus();
              $body.toggleClass('search-open');
            })
            .on('keyup', '.top-search .focus-input', function() {
              $('.top-search input[type="submit"]').css('opacity', '1');
            });

          document.addEventListener('keyup', function(e) {
            if( e.keyCode == 27 ) {
              $body.removeClass('search-open temp-high-z');
            }
          });

          $document.on('click', function(e) {
              const searchWrap = $(".top-search");
              if(!searchWrap.is(e.target) && searchWrap.has(e.target).length === 0) {
                $body.removeClass('search-open temp-high-z');
              }
          });

        }

        $body.find('.searchOverlay [data-searchform] .search__info').on('click', function(){
          $body.find('.searchOverlay [data-searchform]').submit();
        })
        //prevent empty searches on older browsers
        $body.on('submit', '.searchOverlay [data-searchform]', (e) => {
          const searchInputValue = $(e.target).find('[name="s"]').val();
          if(searchInputValue === ''){
            e.preventDefault();
          }
        });

        // Wrap individual words in categories in a span.
        $('article .category a').each(function() {
          const categoryName = $(this).text();
          const categoryNameWords = categoryName.split(' ');
          $(this).html(
            categoryNameWords.map((word) => `<span>${word}</span> `)
          );
        });

      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    process_download: {
      init: function(){
        const registerSuccess = window.getURLParameter('register-success');
        var returnUrl = window.localStorage.getItem('downloadReturnUrl');
        var downloadUrl = window.localStorage.getItem('downloadFile');

        if(registerSuccess == "true"){
          window.localStorage.setItem('hasRegistered', true);
          returnUrl = window.localStorage.getItem('downloadReturnUrl'),
          downloadUrl = window.localStorage.getItem('downloadFile');
        }

        if(downloadUrl && returnUrl){
          console.log('found download link')
          /* Create download link and click it */
          // var downloadLink = document.createElement("a");

          // /* Create anchor tag */
          // downloadLink.setAttribute('download','');
          // downloadLink.setAttribute('id', 'download-file');
          // downloadLink.classList.add('hiddennone');
          // downloadLink.href = downloadUrl;

          // /* Append to body */
          // $body.append(downloadLink);

          
          /* Go back to initial page */
          // window.open(downloadUrl, '_blank');
          const downloadLink = document.createElement('a');
          downloadLink.setAttribute('id', 'download-file');
          downloadLink.href = downloadLink;
          downloadLink.download = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);

          // Append the link to the DOM (this is required for the download to work in some browsers)
          $body.append(downloadLink);
          
          /* Click after a short delay */
          setTimeout(function(){
            $body.find('#download-file')[0].click().remove();
            console.log('here')
          }, 1000);
          // Click the link to start the download
          downloadLink.click();

          // Remove the link (it's not needed anymore)
          window.location.href = returnUrl;
        }
      }
    },
    external_link_warning: {
      init: function(){
        const $hostname = window.location.hostname;
        const $links = $('main a');

        /* Run on link click */
        $links.on('click', function(e){
          /* If hostname of this link is not site window hostname */
          if(this.hostname && this.hostname != $hostname){
            /* Prevent link click */
            e.preventDefault();

            /* Change link for modal button */
            $('.btn-continue').attr('href', this.href);

            /* Show modal */
            $('#external-link-modal').addClass('active');
          }
        });

        /* Close overlay modal */
        $('.overlayModal .close, .overlayModal .go-back').on('click', function() {
          $('.overlayModal.active').removeClass('active');
          return false;
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var namespace = Base;
      funcname = (funcname === undefined) ? 'init' : funcname;
      if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
        UTIL.fire(classnm);
      });
    }
  };

  $document.ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
